import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { MaskFilter, MaskGroup, SliceName } from '@/shared/config';

export type MaskFiltersState = {
  isLandmarksShown: boolean;
  filters: MaskFilter;
  filterIDs: Record<string, boolean>;
};

type InitialState = MaskFiltersState;

const initialState: InitialState = {
  filters: {
    perio: {
      isActive: true,
      disabled: false,
      hide: false,
    },
    restorative: {
      isActive: true,
      disabled: true,
      hide: false,
    },
    endo: {
      isActive: true,
      disabled: true,
      hide: false,
    },
    chart: {
      isActive: true,
      disabled: false,
      hide: false,
    },
  },
  isLandmarksShown: true,
  filterIDs: {},
};

const renderMasksSlice = createSlice({
  name: SliceName.maskFilters,
  initialState,
  reducers: {
    toggleFilter: (state, { payload }: PayloadAction<MaskGroup>) => {
      if (payload === 'perio') {
        state.isLandmarksShown = !state.isLandmarksShown;
      }

      state.filters[payload].isActive = !state.filters[payload].isActive;
    },
    setFilterDisabled: (
      state,
      { payload }: PayloadAction<[MaskGroup, boolean]>,
    ) => {
      const [filterKey, isDisabled] = payload;

      state.filters[filterKey].disabled = isDisabled;
    },
    setFilterIDs: (state, { payload }: PayloadAction<string>) => {
      state.filterIDs[payload] = true;
    },
    clearFilters: (state) => {
      state.filters = initialState.filters;
      state.filterIDs = {};
    },
    setState: (state, { payload }: PayloadAction<InitialState>) => {
      state.filters = payload.filters;
      state.isLandmarksShown = payload.isLandmarksShown;
      state.filterIDs = payload.filterIDs;
    },
  },
});

export const { actions } = renderMasksSlice;

export default renderMasksSlice.reducer;
